/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ClientDTO {
  allowedToManuallyImport?: boolean;
  caseNumber?: string;
  caseType?: ClientDTO.CaseTypeEnum;
  city?: string;
  courtId?: number;
  createdAt?: string;
  dateOfBirth?: string;
  email?: string;
  endDate?: string;
  firstName?: string;
  firstNameInitials?: string;
  houseNumber?: string;
  houseNumberSuffix?: string;
  id?: number;
  insertion?: string;
  lastName?: string;
  numberOfUncategorisedTransactions?: number;
  secondUserId?: number;
  startDate?: string;
  street?: string;
  userId?: number;
  zipCode?: string;
}

export namespace ClientDTO {
  export type CaseTypeEnum = 'BM' | 'CB';
  export const CaseTypeEnum = {
    Bm: 'BM' as CaseTypeEnum,
    Cb: 'CB' as CaseTypeEnum
  };
}


